import { render, staticRenderFns } from "./ImageMessageItem.vue?vue&type=template&id=06d1c6ff&"
import script from "./ImageMessageItem.vue?vue&type=script&lang=js&"
export * from "./ImageMessageItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports